/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { createContext, useContext } from 'react';
/** Shared reservation contract for desktop bounds and Agent surfaces (PA-4471). */
export const DesktopLayoutContext = createContext<{
  reservedRight: number;
  reserveRight: (width: number) => void;
} | null>(null);

export const useDesktopLayout = () => useContext(DesktopLayoutContext);

/**
 * CSS variable (on `<html>`) carrying the reserved right edge: the desktop content layer and fixed
 * chrome such as the dock size themselves from it, so a live resize needs no React render.
 */
export const DESKTOP_RESERVED_RIGHT_VAR = '--desktop-reserved-right';

/** Set on `<html>` while the Agent column is being resized: layout animations pause. */
export const DESKTOP_RESIZING_ATTRIBUTE = 'data-desktop-resizing';

export const setReservedRightVar = (width: number) =>
  document.documentElement.style.setProperty(DESKTOP_RESERVED_RIGHT_VAR, `${width}px`);

export const setDesktopResizing = (resizing: boolean) =>
  document.documentElement.toggleAttribute(DESKTOP_RESIZING_ATTRIBUTE, resizing);
